<template>
  <div style="padding: 0 20px 20px">
    <el-form :model="form" :rules="rules" ref="bundleForm" label-width="120px">
      <el-form-item label="项目包名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入服务项目包名称"></el-input>
      </el-form-item>
      <el-form-item label="所属组织" prop="oid">
        <el-cascader v-fixZoom v-model="form.oid" :options="orgTree" :props="orgCascaderProps"
                     filterable clearable placeholder="请选择所属组织" style="width:100%"></el-cascader>
      </el-form-item>
      <el-form-item label="服务内容" prop="ss_id">
        <el-cascader v-fixZoom v-model="form.ss_id" :options="serviceTypeTree" :props="stCascaderProps"
                     filterable clearable placeholder="请选择服务内容" style="width:100%">
          <template #default="{data}">
            <span v-if="data.is_service !== 1" style="font-style:italic;color:#999999">{{ data.typename }}</span>
            <strong v-else style="color:#1a1a1a">{{ data.typename }}</strong>
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item label="服务次数" prop="target_count">
        <el-input-number v-model="form.target_count" :min="1" :max="99999" style="width:100%"></el-input-number>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="有效开始日期" prop="valid_start_date">
            <el-date-picker v-fixZoom v-model="form.valid_start_date" type="date" value-format="yyyy-MM-dd"
                            placeholder="有效开始日期" style="width:100%"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效结束日期" prop="valid_end_date">
            <el-date-picker v-fixZoom v-model="form.valid_end_date" type="date" value-format="yyyy-MM-dd"
                            placeholder="有效结束日期" style="width:100%"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div>
      <el-row style="margin: 0 30px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeDialog"><span>取消</span></div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitForm"><span>确定</span></div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import {
  querysuppliertype,
  createserviceprojectbundle,
  updateserviceprojectbundle
} from '../../../api/serviceMark'

export default {
  name: 'addEditServiceProjectBundle',
  model: { prop: 'addEditShow', event: 'change' },
  props: {
    addEdit: { type: Object, default: null },
    orgTree: { type: Array, default: () => [] }
  },
  data () {
    return {
      isAdd: true,
      serviceTypeTree: [],
      allServiceTypes: [],
      orgCascaderProps: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'child',
        emitPath: false
      },
      stCascaderProps: {
        checkStrictly: true,
        value: 'id',
        label: 'typename',
        children: 'child',
        emitPath: false,
        disabled: 'isService'
      },
      form: {
        id: 0,
        name: '',
        oid: '',
        ss_id: '',
        target_count: 10,
        valid_start_date: '',
        valid_end_date: '',
        remark: ''
      },
      rules: {
        name: [{ required: true, message: '请输入服务项目包名称', trigger: 'blur' }],
        oid: [{ required: true, message: '请选择所属组织', trigger: 'change' }],
        ss_id: [{ required: true, message: '请选择服务内容', trigger: 'change' }],
        target_count: [{ required: true, message: '请输入服务次数', trigger: 'blur' }],
        valid_start_date: [{ required: true, message: '请选择有效开始日期', trigger: 'change' }],
        valid_end_date: [{ required: true, message: '请选择有效结束日期', trigger: 'change' }]
      }
    }
  },
  created () {
    this.isAdd = this.addEdit.isAdd
    if (!this.isAdd && this.addEdit.row) {
      let r = this.addEdit.row
      this.form.id = r.id
      this.form.name = r.name
      this.form.oid = r.oid
      this.form.ss_id = r.ss_id || r.st_id || ''
      this.form.target_count = r.target_count
      this.form.valid_start_date = r.valid_start_date || ''
      this.form.valid_end_date = r.valid_end_date || ''
      this.form.remark = r.remark || ''
    }
    this.loadServiceTypeTree()
  },
  methods: {
    loadServiceTypeTree () {
      querysuppliertype({ page: 1, size: 99999 }, { orgid: [] }).then(res => {
        const arr = (res.data.types || []).map(o => {
          o.isService = o.is_service === 0
          return o
        })
        this.allServiceTypes = arr
        let minLevel = arr.reduce((min, o) => Math.min(min, o.level), 100)
        let roots = arr.filter(o => o.level === minLevel)
        roots.forEach(root => {
          const children = this.arrayToTypeNode(arr, root.id)
          if (children.length) root.child = children
        })
        this.serviceTypeTree = roots
      }).catch(() => {})
    },
    arrayToTypeNode (arr, pid) {
      return arr.filter(o => o.upid === pid).map(o => {
        const children = this.arrayToTypeNode(arr, o.id)
        if (children.length) o.child = children
        return o
      })
    },
    closeDialog () {
      this.$emit('change', false)
    },
    submitForm () {
      this.$refs.bundleForm.validate(valid => {
        if (!valid) return
        // 校验必须选中服务项目节点（is_service === 1）
        const selectedNode = this.allServiceTypes.find(o => o.id === this.form.ss_id)
        if (!selectedNode || selectedNode.is_service !== 1) {
          this.$message({ message: '请选择具体的服务内容（加粗文字节点）', type: 'warning' })
          return
        }
        const data = {
          name: this.form.name,
          oid: this.form.oid,
          ss_id: this.form.ss_id,
          st_id: this.form.ss_id,
          target_count: this.form.target_count,
          valid_start_date: this.form.valid_start_date,
          valid_end_date: this.form.valid_end_date,
          remark: this.form.remark
        }
        if (this.isAdd) {
          createserviceprojectbundle(data).then(() => {
            this.$notify({ title: '成功', message: '新建服务项目包成功', type: 'success', duration: 2000 })
            this.$emit('refresh')
            this.$emit('change', false)
          }).catch(() => {})
        } else {
          updateserviceprojectbundle(Object.assign({ id: this.form.id }, data)).then(() => {
            this.$notify({ title: '成功', message: '修改服务项目包成功', type: 'success', duration: 2000 })
            this.$emit('refresh')
            this.$emit('change', false)
          }).catch(() => {})
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/childComponents/addEditServiceProjectBundle.vue